var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("common.routing.flagCACP.entity_group.page") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start mb-5" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "4", lg: "2", xl: "1" } },
                  [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "6", lg: "3", xl: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        on: {
                          click: function ($event) {
                            _vm.displayFilter = !_vm.displayFilter
                          },
                        },
                      },
                      [
                        _vm.displayFilter
                          ? _c("i", { staticClass: "fa-light fa-minus" })
                          : _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("filter.fltr")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "6", lg: "3", xl: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "6", lg: "6", xl: "4" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.actionAdd },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("common.routing.flagCACP.entity_group.add")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "justify-content-start align-items-center",
                class: {
                  "filter-item-section": true,
                  "d-none": !_vm.displayFilter,
                },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "filter-item mb-5",
                    attrs: { sm: "6", lg: "3", cols: "12" },
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "filter-item-title",
                        attrs: { for: "filter-name" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("common.routing.flagCACP.entity_group.name")
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "filter-item-content" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.Name,
                            expression: "Name",
                            modifiers: { trim: true },
                          },
                        ],
                        class: {
                          "filter-item-input": true,
                          "filter-item-input-complete": _vm.Name,
                        },
                        staticStyle: { width: "100%" },
                        attrs: {
                          id: "filter-name",
                          type: "text",
                          placeholder: _vm.$t(
                            "common.routing.flagCACP.entity_group.name"
                          ),
                        },
                        domProps: { value: _vm.Name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.Name = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.displayFilter
              ? _c(
                  "b-row",
                  { staticClass: "justify-content-end" },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "mt-4 mb-5",
                        attrs: { sm: "4", lg: "2", cols: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mr-3",
                            attrs: {
                              size: "sm",
                              disabled: _vm.activateSpinner,
                            },
                            on: { click: _vm.clearFilterFields },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("filter.clr_fltr_field")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "mt-4 mb-5",
                        attrs: { sm: "4", lg: "2", cols: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            attrs: { size: "sm" },
                            on: { click: _vm.onRefresh },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.srch")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mb-5" },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "div",
                    { staticStyle: { overflow: "auto" } },
                    [
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _vm.entityGroupList.length > 0
                        ? _c("b-table", {
                            key: _vm.refreshKey,
                            staticClass: "table-striped",
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              items: _vm.entityGroupList,
                              fields: _vm.fields,
                              hover: "",
                              selectable: _vm.entityGroupList.length > 0,
                              "empty-text": _vm.$t("common.security.no_result"),
                            },
                            on: { "row-selected": _vm.onRowClicked },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(Name)",
                                fn: function (data) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.value))]),
                                  ]
                                },
                              },
                              {
                                key: "cell(edit)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-3 w-100",
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionEdit(
                                              $event,
                                              data.item.IdEntityGroup
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-pencil",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(delete)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-3 w-100",
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionDelete(
                                              $event,
                                              data.item.IdEntityGroup
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-trash",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          })
                        : _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("span", { staticClass: "noResult" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.no_result")) +
                                    "\n              "
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }